// authService.js

import cacheService from '../../services/cacheService';

const API_PREFIX = '/api';

export const getCurrentUser = () => {
  // Now we rely on the user object in localStorage only, not the token
  const userStr = localStorage.getItem('user');
  if (!userStr) return null;
  
  try {
    return JSON.parse(userStr);
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

export const logoutUser = async () => {
  try {
    // Check if device is trusted BEFORE clearing anything
    const isTrusted = cacheService.isTrustedDevice();
    
    // Call the logout endpoint to clear the cookie
    await fetch(API_PREFIX + '/auth/logout', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    // Clear cache for UNTRUSTED devices only
    if (!isTrusted) {
      console.log('🗑️ Clearing cache (untrusted device)');
      await cacheService.clearCache();
    } else {
      console.log('✅ Keeping cache (trusted device - offline access available)');
    }
    
  } catch (error) {
    console.error('Error during logout:', error);
  } finally {
    // Always clear session data (user object)
    localStorage.removeItem('user');
    
    // Navigate to login
    // Check if we're in dev path and maintain it
    if (window.location.pathname.includes('/dev')) {
      window.location.href = '/dev/login';
    } else {
      window.location.href = '/login';
    }
  }
};